export const BOOKING_NOTIF_COLOR = 'blue'
export const TRIP_NOTIF_COLOR = 'red'